namespace Gamification.Gamification {
    export interface AziendeForm {
        RagioneSociale: Serenity.StringEditor;
    }

    export class AziendeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Aziende';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AziendeForm.init)  {
                AziendeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(AziendeForm, [
                    'RagioneSociale', w0
                ]);
            }
        }
    }
}
